import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { WaitlistForm } from "./WaitlistForm";

const EASE = [0.16, 1, 0.3, 1];

const Line = ({ children, delay, className = "" }) => (
    <span className="block overflow-hidden pb-[0.09em] -mb-[0.09em]">
        <motion.span
            className={`block ${className}`}
            initial={{ y: "112%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.05, ease: EASE, delay }}
        >
            {children}
        </motion.span>
    </span>
);

export const Hero = () => {
    const ref = useRef(null);
    const { scrollY } = useScroll();
    const glowY = useTransform(scrollY, [0, 700], [0, 170]);
    const glowScale = useTransform(scrollY, [0, 700], [1, 1.3]);

    return (
        <section
            ref={ref}
            className="relative overflow-hidden px-5 pb-20 pt-28 md:pb-28 md:pt-40"
        >
            <motion.div
                style={{ y: glowY, scale: glowScale }}
                className="pointer-events-none absolute left-1/2 top-[-280px] h-[560px] w-[840px] -translate-x-1/2 rounded-full bg-acid opacity-[0.09] blur-[140px]"
            />
            <div className="relative mx-auto max-w-4xl text-center">
                <motion.div
                    initial={{ opacity: 0, y: 14 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.08, ease: EASE }}
                    className="mb-7 inline-flex items-center gap-2.5 rounded-full border border-white/10 bg-white/[0.03] px-4 py-1.5 md:mb-9"
                    data-testid="hero-eyebrow"
                >
                    <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-acid" />
                    <span className="text-[11px] font-semibold tracking-[0.28em] text-[#9c9c96]">
                        EARLY ACCESS
                    </span>
                </motion.div>

                <h1
                    data-testid="hero-headline"
                    className="font-display mx-auto max-w-5xl text-[clamp(2.75rem,7vw,6rem)] font-black leading-[0.95] tracking-[-0.02em] text-white"
                >
                    <span className="sm:hidden">
                        <Line delay={0.16}>Fitness &amp;</Line>
                        <Line delay={0.26}>Finance.</Line>
                        <Line delay={0.36} className="text-acid">
                            Simplified.
                        </Line>
                    </span>
                    <span className="hidden sm:block">
                        <Line delay={0.16}>Fitness &amp; Finance.</Line>
                        <Line delay={0.3} className="text-acid">
                            Simplified.
                        </Line>
                    </span>
                </h1>

                <motion.div
                    id="waitlist"
                    initial={{ opacity: 0, y: 28 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.9, delay: 0.9, ease: EASE }}
                    className="mt-10 scroll-mt-28 md:mt-12"
                >
                    <WaitlistForm />
                </motion.div>
            </div>
        </section>
    );
};
